export const signalLevelsFormConfig = {
    sections: {
        channelCheck: {
            name: "Channel Check",
            values: [
                {
                    hasChannelNumbers: true,
                    channel: "highChannel",
                    name: 'Tap High Freq',
                    value: 'High',
                    type: 'number',
                },  {
                    hasChannelNumbers: true,
                    channel: "lowChannel",
                    name: 'Tap Low Freq',
                    value: 'Low',
                    type: 'number',
                }
            ]
        },
        docSisCheck: {
            name: "DOC SIS Check",
            values: [
                {
                    hasChannelNumbers: false,
                    channel: null,
                    name: 'TX',
                    value: 'Tx',
                    type: 'number',
                }, {
                    hasChannelNumbers: false,
                    channel: null,
                    name: 'RX',
                    value: 'Rx',
                    type: 'number',
                }, {
                    hasChannelNumbers: false,
                    channel: null,
                    name: 'Downstream MER',
                    value: 'Mer',
                    type: 'number',
                }
            ]
        },
        ingressCheck: {
            name: "Ingress Check",
            values: [
                {
                    hasChannelNumbers: false,
                    channel: null,
                    name: 'Drop To Home',
                    value: 'DropToHome',
                    type: 'bool',
                }
            ]
        }
    }
};



// WEBPACK FOOTER //
// ./src/constants/signalLevelsFormConfig.js